// extracted by mini-css-extract-plugin
module.exports = {"section":"_3cuXv6VdKlEo-uZxy_FzLQ"};